/*
  Универсальный скроллер категорий.
  • БЕЗ Radix – нативный <div> даёт тот же UX и меньше багов.
  • Стрелки появляются, если контент выходит за пределы видимой области.
*/

import React, { useEffect, useRef, useState, memo } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";
import clsx from "clsx";
import { buttonStyles, groupCategoryButtonStyles } from "../../styles/commonStyles";

const STEP = 200; // px за один клик стрелки

export const CategoryScroller = memo(function CategoryScroller({
  categories = [],
  value,
  onSelect,
}) {
  const viewportRef = useRef(null);
  const [can, setCan] = useState({ left: false, right: false });

  /** пересчёт необходимости стрелок */
  const recalc = () => {
    const v = viewportRef.current;
    if (!v) return;
    setCan({
      left: v.scrollLeft > 0,
      right: v.scrollLeft + v.clientWidth < v.scrollWidth,
    });
  };

  /* первый расчёт + слушатели */
  useEffect(() => {
    recalc();
    const v = viewportRef.current;
    if (!v) return;
    v.addEventListener("scroll", recalc);
    window.addEventListener("resize", recalc);
    return () => {
      v.removeEventListener("scroll", recalc);
      window.removeEventListener("resize", recalc);
    };
  }, [categories]);

  const scrollBy = (delta) =>
    viewportRef.current?.scrollBy({ left: delta, behavior: "smooth" });

  return (
    <div className="relative w-full">
      {/* ВИДИМАЯ ОБЛАСТЬ */}
      <div
        ref={viewportRef}
        className="category-scroller-width flex flex-nowrap gap-2 overflow-x-auto scrollbar-none min-w-0 px-1 py-2"
      >
        {categories.map((cat) => (
          <button
            key={cat.id}
            onClick={() => onSelect?.(cat.id)}
            className={clsx(
              'flex-shrink-0',
              groupCategoryButtonStyles,
              value === cat.id
                ? 'bg-blue-500 text-white dark:bg-blue-400 dark:text-white'
                : ''
            )}
            style={{ WebkitTapHighlightColor: "transparent", userSelect: "none" }}
          >
            {cat.name}
          </button>
        ))}
      </div>

      {/* ← */}
      <button
        aria-label="scroll left"
        onClick={() => scrollBy(-STEP)}
        className={clsx(
          "absolute left-0 top-1/2 -translate-y-1/2 rounded-full bg-background/80 p-1 backdrop-blur transition-opacity",
          can.left ? "opacity-100" : "pointer-events-none opacity-0"
        )}
      >
        <ChevronLeft size={20} />
      </button>

      {/* → */}
      <button
        aria-label="scroll right"
        onClick={() => scrollBy(STEP)}
        className={clsx(
          "absolute right-0 top-1/2 -translate-y-1/2 rounded-full bg-background/80 p-1 backdrop-blur transition-opacity",
          can.right ? "opacity-100" : "pointer-events-none opacity-0"
        )}
      >
        <ChevronRight size={20} />
      </button>
    </div>
  );
});
